<template>
  <div class="page">
    <div class="pageTitleBox" style="align-items: center">
      <div class="boxNameL">编辑耗材</div>
      <el-button type="warning" @click="isBack" size="small">返回</el-button>
      <!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
    </div>
    <div class="wrap">
      <el-form
        ref="form"
        style="padding-bottom: 80px"
        :model="editParams"
        label-width="100px"
      >
        <div class="tit">
          <span class="name">基础设置</span>
        </div>
        <el-form-item label="分类">
          <el-cascader
            v-if="showShops"
            size="mini"
            ref="cascader"
            clearable
            v-model="productTypeIds"
            :options="categoryData"
            :show-all-levels="false"
            :props="{ label: 'label', value: 'id' }"
            @change="changeCategory"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="耗材名称" prop="title">
          <el-input
            v-model="editParams.title"
            size="mini"
            style="width: 200px"
            placeholder="请输入商品描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="限制使用次数" prop="title">
          <el-radio-group
            v-model="editParams.count_limit"
            @change="changelimit"
          >
            <el-radio :label="Number('0')">限制</el-radio>
            <el-radio :label="Number('1')">不限制(默认1000次)</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="包装单位" prop="title">
          <el-input
            size="mini"
            style="width: 100px"
            v-model="editParams.packing_unit"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用单位" prop="title">
          <el-input
            size="mini"
            style="width: 100px"
            v-model="editParams.use_unit"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="建议使用次数" prop="title">
          <el-input
            size="mini"
            style="width: 100px"
            v-model="editParams.use_times"
            placeholder="请输入次数"
          ></el-input>
        </el-form-item>
        <el-form-item label="库存警报" prop="title">
          <el-input
            v-model="editParams.stock_alert"
            size="mini"
            style="width: 200px"
            placeholder="请输入商品描述"
          ></el-input>
        </el-form-item>

        <storeSelect
          v-if="showShops"
          title="应用门店"
          :storeIds="storeIds"
          @sendStore="getStores"
        ></storeSelect>

        <el-form-item label="状态" v-if="id != undefined">
          <el-radio-group v-model="editParams.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">暂停</el-radio>
            <el-radio :label="-1">作废</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <div style="margin: auto">
        <el-button
          type="primary"
          size="small"
          :loading="loading"
          @click="submit"
          >确定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  getProductTypeList,
  getProductTypeDl,
  getConsumablesDl,
  setConsumables,
} from "../../../api/productApi.js";
import storeSelect from "../../../components/storeSelect.vue";
export default {
  components: {
    storeSelect,
  },
  data() {
    return {
      id: this.$route.query.id,
      editParams: {
        consumablematerial_id: "",
        title: "",
        category_info: {
          _id: "",
          name: "",
          code: "",
        },
        category_list: [],
        count_limit: 0,
        packing_unit: "",
        use_unit: "",
        use_times: 1,
        shop_info: [],
        stock_alert: 1,
        status: 1,
      },
      storeIds: [],
      productTypeIds: [],
      categoryData: [],
      showShops: true,
      loading: false,
    };
  },
  methods: {
    isBack() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/consumables/consumables",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getProductTypeList() {
      getProductTypeList({
        category: "耗材",
      }).then((res) => {
        if (res.code == 0) {
          console.log(res.data, "-----");
          this.categoryData = res.data[0].children;
        }
      });
    },
    changeCategory(val) {
      if (val.length > 0) {
        getProductTypeDl({
          id: val[val.length - 1],
        }).then((res) => {
          if (res.code == 0) {
            this.editParams.category_info._id = res.data._id;
            this.editParams.category_info.name = res.data.name;
            this.editParams.category_info.code = res.data.code;
            this.editParams.category_list = res.data.parent_all;
          }
        });
      }
    },
    getConsumablesDl(id) {
      // this.productTypeIds =[]
      this.showShops = false;
      getConsumablesDl({
        id,
      }).then((res) => {
        if (res.code == 0) {
          this.editParams = res.data;
          this.storeIds = this.editParams.shop_info.map((item) => {
            return item.shop_id;
          });
          res.data.category_list.forEach((item, index) => {
            if (index > 0) {
              this.productTypeIds.push(item._id);
            }
          });
          this.productTypeIds.push(res.data.category_info._id);
          this.showShops = true;
        }
      });
    },

    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          setConsumables(this.editParams).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.$router.push({
                path: "/consumables/consumables",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    getStores(data) {
      this.editParams.shop_info = data;
    },
    changelimit(val) {
      if (val == 1) {
        this.editParams.use_times = 1000;
      } else {
        this.editParams.use_times = 1;
      }
    },
  },
  created() {
    this.getProductTypeList();
    if (this.$route.query.id) {
      this.getConsumablesDl(this.$route.query.id);
    } else {
      this.storeIds = this.$store.state.userInfo.shops.map((item) => {
        return item.shop_id;
      });
      this.editParams.shop_info = this.$store.state.userInfo.shops;
    }
  },
};
</script>

<style lang="scss" scoped="scoped">
.page {
  .tit {
    font-size: 16px;
    margin-bottom: 28px;
    background-color: #f5f5f5;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    padding-left: 10px;
    .name {
      padding-left: 5px;
      border-left: 2px solid #f5882a;
    }
  }
  .footer {
    // background-color: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    left: 220px;
    right: 0;
    padding-left: 20px;
    z-index: 200;
  }
}
</style>
